import React from 'react'
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack'
import { Grow } from '@mui/material'

const SnackbarProvider: React.FC = (props) => {
  return <NotistackSnackbarProvider
    autoHideDuration={15 * 1000}
    maxSnack={6}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    content={(key, message) => message}
    TransitionComponent={(transitionProps) => {
      // @ts-ignore -- todo - props dont match perfectly, but it works for now
      return <Grow {...transitionProps} />
    }}
  >
    {props.children}
  </NotistackSnackbarProvider>
}

export default SnackbarProvider
